import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import api, { formatApiError } from "../api";
import { useAuth } from "../AuthContext";

export default function Login() {
  const { refresh } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setBusy(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      await refresh();
      nav({ admin: "/english-id/admin", family: "/english-id/family" }[data.role] || "/english-id/student");
    } catch (ex) {
      setErr(formatApiError(ex));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="max-w-md mx-auto mt-10">
      <h1 className="font-serif text-3xl font-bold">Ingresar</h1>
      <p className="text-[13px] text-[#132C44]/70 mt-1">
        Tu English ID — alumnos, familias y staff.
      </p>
      <form onSubmit={submit} className="mt-7 space-y-4" data-testid="eid-login-form">
        <div>
          <label className="text-[12px] font-semibold tracking-widest text-[#132C44]/70 uppercase">
            Email
          </label>
          <input
            type="email"
            required
            autoComplete="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="mt-1 w-full border border-[#132C44]/25 rounded-xl px-4 py-3 bg-white focus:outline-none focus:ring-2 focus:ring-[#132C44]/30"
            data-testid="eid-login-email"
          />
        </div>
        <div>
          <label className="text-[12px] font-semibold tracking-widest text-[#132C44]/70 uppercase">
            Contraseña
          </label>
          <input
            type="password"
            required
            autoComplete="current-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="mt-1 w-full border border-[#132C44]/25 rounded-xl px-4 py-3 bg-white focus:outline-none focus:ring-2 focus:ring-[#132C44]/30"
            data-testid="eid-login-password"
          />
        </div>
        {err && (
          <div
            className="text-[13px] text-[#9B2C3B] bg-[#9B2C3B]/10 border border-[#9B2C3B]/30 px-3 py-2 rounded-lg"
            data-testid="eid-login-error"
          >
            {err}
          </div>
        )}
        <button
          disabled={busy}
          type="submit"
          className="w-full mt-2 py-3 rounded-full bg-[#132C44] text-[#F6EFDF] font-semibold text-[13px] hover:bg-[#1E3A5F] disabled:opacity-60"
          data-testid="eid-login-submit"
        >
          {busy ? "Ingresando…" : "Ingresar"}
        </button>
      </form>
      <p className="mt-5 text-[12px] text-[#132C44]/60">
        Si no podés acceder, pedile a la administración un link de activación o
        restablecimiento. Nunca compartas tu contraseña.
      </p>
    </div>
  );
}
